import { render, staticRenderFns } from "./AzTextViewEditAutoCompleteFornecedor.vue?vue&type=template&id=132d37c5&scoped=true&"
import script from "./AzTextViewEditAutoCompleteFornecedor.vue?vue&type=script&lang=js&"
export * from "./AzTextViewEditAutoCompleteFornecedor.vue?vue&type=script&lang=js&"
import style0 from "./AzTextViewEditAutoCompleteFornecedor.vue?vue&type=style&index=0&id=132d37c5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132d37c5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAutocomplete,VBtn,VIcon,VTooltip})
